import polyglotI18nProvider from 'ra-i18n-polyglot'
import {messages as englishMessages} from './messages/en'
const messages = {
    en: englishMessages
}

export default polyglotI18nProvider(locale => messages[locale], 'en', {
    allowMissing: true
})
